module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.9.2-145.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.9.2.md
// module id = 560
// module chunks = 225